/*
 * @Author: Teemo Ding
 * @Date: 2021-06-29 17:14:47
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-08-25 13:54:55
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelInvoice/index.tsx
 */
import { Skeleton } from '@/src/components/Antd';
import ErrorModal from '@/src/components/ErrorModal/ErrorModal';
import ErrorModalTitle from '@/src/components/ErrorModal/ErrorModalTitle';
import NoPermission from '@/src/components/NoPermission';
import RouteBlock from '@/src/constrains/RouterBlock/RouterBlock';
import Layout from '@/src/layout/EditorPageLayout/EditorPageLayout';
import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import TopRight from '@/src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import { getSalesChannel } from '@/src/request/salesChannel/salesChannel';
import {
  request_invoiceData,
  save_invoiceData,
} from '@/src/request/salesChannel/setting/invoice';
import {
  getCountry,
  getState,
  getStoreDetails,
} from '@/src/request/settings/storeDetails';
import {
  isUserValid,
  salesChannelResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
  EPermissionSource,
} from '@/src/types/common/resources';
import { Form, message } from 'antd';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import ModalHOC from 'src/constrains/ModalHOC';
import AvailableInvoice from './AvailableInvoice';
import { breadcrumbData } from './config';
import css from './css.module.less';
import InvoiceFormat from './InvoiceFormat';
import InvoiceInformation from './InvoiceInformation';
import OtherInformation from './OtherInformation';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const permissions = (uuid: string) => {
  const view_invoice_settings = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelSettings,
        subCategory: EnumSubCategory.ChannelInvoice,
        operation: EnumOperation.view_invoice_settings,
        uuid,
      }),
    ],
  });
  const edit_invoice_settings = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelSettings,
        subCategory: EnumSubCategory.ChannelInvoice,
        operation: EnumOperation.edit_invoice_settings,
        uuid,
      }),
    ],
  });

  return {
    view_invoice_settings,
    edit_invoice_settings,
  };
};
const SalesChannelInvoice = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { modalOp } = props;
  const [form] = Form.useForm();
  const params: any = useParams();
  const history = useHistory();
  const [storeData, setStoreData] = useState({});
  const [information, setInformation] = useState([]);
  const [storeInformation, setStoreInformation] = useState([]);
  const [defaultAreaCode, setDefaultAreaCode] = useState('');
  const [storeInvoiceSetting, setStoreInvoiceSetting] = useState({} as any);
  const [salesChannelInvoiceSetting, setSalesChannelInvoiceSetting] = useState(
    {} as any,
  );
  const [countries, setCountries] = useState<string[]>([]);
  const [states, setStates] = useState([]);
  const [salesChannelName, setSalesChannelName] = useState('');
  const [loading, setLoading] = useState(true);
  const [hasModified, setHasModified] = useState(false);
  const { setShowModal, setModalTitle, setModalContent } = modalOp;
  const { uuid: salesChannelUuid } = params;
  const { view_invoice_settings, edit_invoice_settings } =
    permissions(salesChannelUuid);

  useEffect(() => {
    if (view_invoice_settings) {
      const lang = navigator.language; //获取浏览器默认语言。
      getCountry(lang).then((country) => {
        setDefaultAreaCode(country.uuid);
      });
      getSalesChannel(salesChannelUuid).then((data: any) => {
        setSalesChannelName(data.name);
      });
      request_invoiceData(salesChannelUuid).then((data) => {
        setStoreData(data.store);
        setInformation(
          (data.salesChannelInvoiceSetting.information || {}).items || [],
        );
        setStoreInvoiceSetting(data.storeInvoiceSetting || ({} as any));
        setSalesChannelInvoiceSetting(data.salesChannelInvoiceSetting || {});
        setStoreInformation(
          (data.salesChannelInvoiceSetting.storeInformation || {}).items || [],
        );
        setLoading(false);
      });
      getStoreDetails().then((data) => {
        setCountries(data.countries);
        if (data.store.country.code) {
          getState(data.store.country.code).then((state) => setStates(state));
        }
      });
    }
  }, []);

  const goBackToList = () => {
    history.push({
      pathname: `/salesChannel/settings/${salesChannelUuid}`,
    });
  };

  const topLeft = (
    <TopLeft
      goBack={goBackToList}
      breadcrumbData={breadcrumbData(salesChannelName, salesChannelUuid, {
        getI18n,
      })}
    />
  );

  const addInformation = (item) => {
    const informationCopy = _.cloneDeep(information);
    informationCopy.push(item);
    setInformation(informationCopy);
    setShowModal(false);
    setHasModified(true);
  };

  const editInformation = (record) => {
    const informationCopy = _.cloneDeep(information);
    setInformation(
      informationCopy.map((item) => (item.uuid == record.uuid ? record : item)),
    );
    setShowModal(false);
    setHasModified(true);
  };
  const deleteInformation = (record) => {
    setShowModal(true);
    setModalTitle(
      <ErrorModalTitle>
        {getI18n('general.deletethisinformation')}
      </ErrorModalTitle>,
    );
    setModalContent(
      <ErrorModal
        setModal={setShowModal}
        onSubmit={() => handleDelete(record)}
        okText={getI18n('general.delete')}
        errorText={getI18n('storeInvoice.detail.deleteOne')}
      />,
    );
  };

  const handleDelete = (record) => {
    const informationCopy = _.cloneDeep(information);
    const arrDelete = informationCopy.filter(
      ({ uuid }) => uuid !== record.uuid,
    );
    setInformation(arrDelete);
    setHasModified(true);
  };

  const topRight = (
    <TopRight
      onDiscard={goBackToList}
      onSubmit={() => {
        form.submit();
      }}
      onSaveDisable={!hasModified || !edit_invoice_settings}
    />
  );

  const onFinish = (values) => {
    values['information'] = {};
    values['information']['items'] = information;
    values['storeInformation'] = {};
    values['storeInformation']['items'] = storeInformation;
    if (values.informationCustomized) {
      values = {
        ...values,
        ...{
          entityNameEnabled: values.entityNameEnabledCustomized,
          entityRegistrationNumberEnabled:
            values.entityRegistrationNumberEnabledCustomized,
          storeNameEnabled: values.storeNameEnabledCustomized,
          phoneEnabled: values.phoneEnabledCustomized,
          addressEnabled: values.addressEnabledCustomized,
          emailEnabled: values.emailEnabledCustomized,
          paymentEnabled: values.paymentEnabledCustomized,
          phone: values.phone,
          areaCodeInfo: values.areaCodeInfo,
          email: values.email,
          address: values.address,
          title: values.titleCustomized,
          logo: values.logoCustomized,
        },
      };
    }
    if (values.prefixCustomized) {
      values = {
        ...values,
        ...{ prefix: values.prefixCustomizedText },
      };
    }

    if (values.suffixCustomized) {
      values = {
        ...values,
        ...{ suffix: values.suffixCustomizedText },
      };
    }
    save_invoiceData(salesChannelUuid, values).then(() => {
      message.success(getI18n('general.savesuccess'));
      setHasModified(false);
    });
  };
  const checkChange = (record) => {
    const informationCopy = _.cloneDeep(storeInformation);
    record.enabled = !record.enabled;
    setStoreInformation(
      informationCopy.map((item) => (item.uuid == record.uuid ? record : item)),
    );
    setHasModified(true);
  };

  const Child = [
    {
      child: (
        <AvailableInvoice form={form} disableEdit={!edit_invoice_settings} />
      ),
    },
    {
      child: (
        <InvoiceInformation
          storeData={storeData}
          states={states}
          countries={countries}
          disableEdit={!edit_invoice_settings}
        />
      ),
    },
    {
      child: <InvoiceFormat disableEdit={!edit_invoice_settings} />,
    },
    {
      child: (
        <OtherInformation
          information={information}
          storeInformation={storeInformation}
          setShowModal={setShowModal}
          setModalTitle={setModalTitle}
          setModalContent={setModalContent}
          addInformation={addInformation}
          editInformation={editInformation}
          deleteInformation={deleteInformation}
          checkChange={checkChange}
          disableEdit={!edit_invoice_settings}
        />
      ),
    },
  ];
  return view_invoice_settings ? (
    <Skeleton loading={loading} active>
      <RouteBlock
        onConfirm={(f) => f()}
        okText={getI18n('general.discard')}
        active={hasModified}
        title={getI18n('general.commonHeader.discard_header')}
        content={getI18n('general.commonHeader.discard_content')}
      />
      <Form
        name='invoice'
        form={form}
        onFinish={onFinish}
        onValuesChange={() => {
          setHasModified(true);
        }}
        className={css.invoiceContainerForm}
        initialValues={{
          ...storeInvoiceSetting,
          ...{
            downloadable: salesChannelInvoiceSetting.downloadable,
            printable: salesChannelInvoiceSetting.printable,
            downloadSize: salesChannelInvoiceSetting.downloadSize || 'A4',
            printSize: salesChannelInvoiceSetting.printSize || 'A4',
            informationCustomized:
              salesChannelInvoiceSetting.informationCustomized,
            prefixCustomized: salesChannelInvoiceSetting.prefixCustomized,
            suffixCustomized: salesChannelInvoiceSetting.suffixCustomized,
            phoneEnabledCustomized: salesChannelInvoiceSetting.phoneEnabled,
            phone: salesChannelInvoiceSetting.phone,
            areaCodeInfo:
              salesChannelInvoiceSetting.areaCodeInfo || defaultAreaCode
                ? { uuid: defaultAreaCode }
                : '',
            storeNameEnabledCustomized:
              salesChannelInvoiceSetting.storeNameEnabled,
            emailEnabledCustomized: salesChannelInvoiceSetting.emailEnabled,
            email: salesChannelInvoiceSetting.email,
            addressEnabledCustomized: salesChannelInvoiceSetting.addressEnabled,
            address: salesChannelInvoiceSetting.address,
            paymentEnabledCustomized: salesChannelInvoiceSetting.paymentEnabled,
            prefixCustomizedText: salesChannelInvoiceSetting.prefix,
            suffixCustomizedText: salesChannelInvoiceSetting.suffix,
            entityNameEnabledCustomized:
              salesChannelInvoiceSetting.entityNameEnabled,
            entityRegistrationNumberEnabledCustomized:
              salesChannelInvoiceSetting.entityRegistrationNumberEnabled,
            titleCustomized: salesChannelInvoiceSetting.title,
            subdivision: salesChannelInvoiceSetting.subdivision,
            addressLine: salesChannelInvoiceSetting.addressLine,
            postCode: salesChannelInvoiceSetting.postCode,
            logoCustomized: salesChannelInvoiceSetting.logo,
          },
        }}>
        <Layout elements={Child} topLeft={topLeft} topRight={topRight}></Layout>
      </Form>
    </Skeleton>
  ) : (
    <NoPermission />
  );
};

export default ModalHOC(SalesChannelInvoice);
